export const convertToQuery = (obj: Record<string, unknown>) =>
  new URLSearchParams(obj as unknown as URLSearchParams).toString();
